import React, { useState, useEffect } from 'react';
import { masterAdminAPI } from '../../services/api';
import toast from 'react-hot-toast';

const TransactionsList = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTransactions();
  }, []);

  const fetchTransactions = async () => {
    try {
      // Assuming we have an endpoint to get all credit transactions across schools
      // If not, we might need to loop through schools or create a new backend endpoint.
      // For now, we'll fetch all schools and then their transactions (inefficient).
      // Better to have a dedicated endpoint: /master/transactions
      // We'll assume such endpoint exists.
      const res = await masterAdminAPI.getAllTransactions?.(); 
      // If not, fallback: fetch schools then aggregate
      if (masterAdminAPI.getAllTransactions) {
        setTransactions(res.data);
      } else {
        // fallback: fetch all schools and combine transactions
        const schoolsRes = await masterAdminAPI.getAllSchools();
        const allTransactions = [];
        for (const school of schoolsRes.data) {
          const transRes = await masterAdminAPI.getSchoolTransactions(school.id);
          allTransactions.push(...transRes.data.map(t => ({ ...t, school_name: school.name })));
        }
        setTransactions(allTransactions.sort((a, b) => new Date(b.created_at) - new Date(a.created_at)));
      }
    } catch (error) {
      toast.error('Failed to load transactions');
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="text-center py-8">Loading transactions...</div>;

  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">All Credit Transactions</h1>
      {transactions.length === 0 ? (
        <p className="text-gray-500">No transactions found.</p>
      ) : (
        <div className="bg-white rounded-lg shadow overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  School
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Type
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Amount
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Reference
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Description
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Date
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {transactions.map((tx) => (
                <tr key={tx.id}>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                    {tx.school_name || tx.school_id}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 capitalize">
                    {tx.transaction_type}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {tx.amount} credits
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {tx.reference_id || '-'}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {tx.description}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {new Date(tx.created_at).toLocaleString()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default TransactionsList;